import * as React from 'react';
import {Input} from 'reactstrap';

import CustomScrollbars from '../../../common/CustomScrollbar';

import FormField from './FormFieldClass';

import {LargeButton, InputWrapper,InputLabelWrapper, Option, StyledInput} from './FormField.styles'

import {Modal, ModalHeader, ModalBody} from 'reactstrap';

interface IProps {
    className?: string;
    maxHeight?: number;
    title?: string;
    toggle?: any;
    formsubmit?: any;
    values?: any;
    formfields: FormField[];
    visible?: boolean;
    isbusy?: boolean;
}

export default class FormModal extends React.Component<IProps> {
    public static defaultProps = {
      maxHeight: 500,
    }

    constructor(props) {
        super(props);
    }

    public handleChange(id, e) {
        console.log(e)
        this.props.values[id] = e.target.value;
        this.forceUpdate();
    }

    public renderInputs(d) {

        if (d.type=== 'option') {
            return (
                <InputWrapper>
                {/*tslint:disable-next-line jsx-no-lambda*/}
                <Input id={d.id} required={d.required} placeholder={d.placeholder} type="select" value={this.props.values[d.id]} onChange= {(e) => this.handleChange(d.id, e)}>
                    <option value=''>{d.placeholder}</option>
                    {this.renderOptions(d.options.items, d.options.idkey, d.options.labelkey, d.options.valuekey)}
                </Input>
                </InputWrapper>
            )
        }

        else if (d.type=== 'number') {
            return (
                <InputWrapper>
                {/*tslint:disable-next-line jsx-no-lambda*/}
                <StyledInput id={d.id} required={d.required} placeholder={d.placeholder} type={d.type} max={d.dim.max} min={d.dim.min}  value={this.props.values[d.id]} onChange= {(e) => this.handleChange(d.id, e)} />
                
                </InputWrapper>
                )
        }
        else{
            return (
            <InputWrapper>
            {/*tslint:disable-next-line jsx-no-lambda*/}
            <StyledInput id={d.id} required={d.required} placeholder={d.placeholder} type={d.type}  value={this.props.values[d.id]} onChange= {(e) => this.handleChange(d.id, e)} />
            
            </InputWrapper>
            )
        }
        
    }

    public renderOptions(options, idkey, labelkey, valuekey) {
        return(
            options.map(
            (d, i) =>
            <Option key={d[idkey]} value={d[valuekey]}>
                {d[labelkey]}
            </Option>
            )
        );
    }

    public renderForm() {
        return (
            <form onSubmit={this.props.formsubmit}>
                {this.props.formfields.map(
                    (d, i) =>
                     <div key={d.id}> 
                        <InputLabelWrapper>
                            <label htmlFor={d.id} style={{ display: 'block' }}>
                                {d.name}
                            </label>
                        </InputLabelWrapper>
                        {this.renderInputs(d)}
                     </div>)}
                <br/><br/>
                <LargeButton type="submit" disabled={this.props.isbusy} className="submit-butto">
                    Submit
                </LargeButton>
            </form>
        );

    }

    public render() {
        const { title, className} = this.props;
    
        return (
          <CustomScrollbars >
              <Modal isOpen={this.props.visible} toggle={this.props.toggle} className={className}>
                    <ModalHeader toggle={this.props.toggle}>{title}</ModalHeader>
                    <ModalBody>
                        {this.props.formfields.length >0?this.renderForm(): <p>No items to display</p>}
                    </ModalBody>
              </Modal>
            
          </CustomScrollbars>
        );
      }
}


// WEBPACK FOOTER //
// ./src/components/Admin/FormModal/FormModal.tsx